<template>
  <div class="event-tabs">
    <div
      class="tab-item"
      :class="{ active: activeTab === 'guests' }"
      @click="$emit('change', 'guests')"
    >
      Invitados
    </div>

    <div
      class="tab-item"
      :class="{ active: activeTab === 'scheduled' }"
      @click="$emit('change', 'scheduled')"
    >
      Envios Programados
    </div>

    <div
      class="tab-item"
      :class="{ active: activeTab === 'history' }"
      @click="$emit('change', 'history')"
    >
      Historial
    </div>

    <div
      v-if="blacklistCount > 0"
      class="tab-item"
      :class="{ active: activeTab === 'blacklist' }"
      @click="$emit('change', 'blacklist')"
    >
      Black List ({{ blacklistCount }})
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventTabs',
  props: {
    activeTab: {
      type: String,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
    blacklistCount: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.event-tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-top: 10px;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  border-bottom: 3px solid transparent;
}

.tab-item.active {
  border-bottom: 3px solid #321fdb; /* color principal */
  font-weight: 600;
}
</style>
